<form [formGroup]="form" class="flex flex-col w-full">
  <div
    class="flex items-center gap-2 w-full flex-col sm:flex-row justify-center sm:justify-start"
  >
    <rms-time-picker
      class="w-full sm:max-w-32 md:max-w-40"
      formControlName="from"
      [interval]="interval"
    />
    <div class="swap-button">
      <div class="range-icon block font-semibold h-6 w-6 text-center">
        &mdash;
      </div>
      <mat-icon
        class="swap-icon hover:cursor-pointer"
        svgIcon="remix:Arrows/arrow-left-right-fill"
        (click)="swapValues()"
      />
    </div>
    <rms-time-picker
      class="w-full sm:max-w-32 md:max-w-40"
      formControlName="to"
      [interval]="interval"
    />
  </div>
  @if (form.errors && form.errors["invalidRange"]) {
    <mat-error translate>libs.common.time.invalid-range</mat-error>
  } @else if (form.errors && form.errors["required"]) {
    <mat-error translate>libs.common.time.required-interval</mat-error>
  }
</form>
